import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/Dashboard";

//Authentication pages
import Login from "src/pages/Authentication/Login";
import Logout from "src/pages/Authentication/Logout";
import Register from "src/pages/Authentication/Register";
import ForgetPassword from "src/pages/Authentication/ForgetPassword";
import UserProfile from "src/pages/Authentication/user-profile";
import { Users } from "src/pages/Users/Users";
import { Settings } from "src/pages/Settings/Settings";
import { SettingTypes } from "src/pages/SettingTypes/SettingTypes";
import { Error404 } from "src/pages/Utility/Error404";
import { GeneralConfigurations } from "src/pages/GeneralConfigurations/GeneralConfigurations";
import { UsersToValidate } from "src/pages/UsersToValidate/UsersToValidate";
import { ReportedMessages } from "src/pages/ReportedMessages/ReportedMessages";
import { RejectedUsers } from "src/pages/RejectedUsers/RejectedUsers";
import { Groups } from "src/pages/Groups";
import { UsersByGroup } from "src/pages/UsersByGroup";
import { Notifications } from "src/pages/Notifications";
import { NotificationManager } from "src/pages/NotificationManager";
import { RatingAndFeedback } from "src/pages/RatingAndFeedback";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

const userRoutes: Array<RouteProps> = [
  //User Profile
  // { path: "/profile", component: <UserProfile /> },

  //dashboard
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/users", component: <Users />},
  { path: "/groups", component: <Groups />},
  { path: "/users-by-group", component: <UsersByGroup />},
  { path: "/rating-and-feedback", component: <RatingAndFeedback />},
  { path: "/users-to-validate", component: <UsersToValidate />},
  { path: "/rejected-users", component: <RejectedUsers />},
  { path: "/notifications", component: <Notifications />},
  { path: "/notification-manager", component: <NotificationManager />},
  { path: "/reported-messages", component: <ReportedMessages />},
  { path: "/settings", component: <Settings />},
  { path: "/setting-types", component: <SettingTypes />},
  { path: "/general-configurations", component: <GeneralConfigurations /> },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: <Navigate to="/users" /> },
];

const authRoutes: Array<RouteProps> = [
  //Authentication pages
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/register", component: <Register /> },
  { path: "/recoverpw", component: <ForgetPassword /> },
  { path: "/*", component: <Error404 /> },

];

export { userRoutes, authRoutes };
